{
  "version": 1,
  "asset_id": "8f82e71b-670e-4b72-af5a-4c3b9b1e0f23",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/8f82e71b-670e-4b72-af5a-4c3b9b1e0f23/ind-legal-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/8f82e71b-670e-4b72-af5a-4c3b9b1e0f23/ind-legal-1200.webp",
  "original_filename": "ind-legal-1200.webp",
  "size": 11384,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:06Z"
}
